/** @format */
import { NodeRenderer, Options } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';

import { ContentfulBold } from '../components/bold';
import {
    ContentfulHeadingH1,
    ContentfulHeadingH2,
    ContentfulHeadingH3,
    ContentfulHeadingH4,
    ContentfulHeadingH5,
} from '../components/heading';
import { ContentfulLink } from '../components/link';

export const defaultDocumentOptions: Options = {
    renderNode: {
        /*
         * Casting to NodeRenderer to satisfy the type checker as
         * Contentful types are not compatible with themselves.
         * This keeps the component implementations type safe.
         */
        [BLOCKS.HEADING_1]: ContentfulHeadingH1 as NodeRenderer,
        [BLOCKS.HEADING_2]: ContentfulHeadingH2 as NodeRenderer,
        [BLOCKS.HEADING_3]: ContentfulHeadingH3 as NodeRenderer,
        [BLOCKS.HEADING_4]: ContentfulHeadingH4 as NodeRenderer,
        [BLOCKS.HEADING_5]: ContentfulHeadingH5 as NodeRenderer,
        [INLINES.HYPERLINK]: ContentfulLink as NodeRenderer,
    },
    renderMark: {
        [MARKS.BOLD]: ContentfulBold,
    },
};
